import moment from "moment";

// Capitalize first letter
export function capitalizeUsername(username: string): string {
  if (!username) return "";

  return username
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

// date format (i.e May 24, 2025)
export function formatToLongDate(date: string | number | Date): string {
  return moment(date).format("MMMM D, YYYY");
}

export const formatToSlug = (text: string): string => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[\s\/]+/g, "-") // replace spaces and slashes with dashes
    .replace(/[^a-z0-9-]/g, "") // remove all other special characters
    .replace(/-+/g, "-") // collapse multiple dashes
    .replace(/^-+|-+$/g, ""); // remove leading/trailing dashes
};

export const splitName = (fullName: string) => {
  const parts = fullName.trim().split(" ");
  return {
    firstName: parts[0] || "",
    lastName: parts.length > 1 ? parts.slice(1).join(" ") : "",
  };
};
